<template>
	<table class="table">
		<thead class="table__head">
			<tr class="table__row table__row--headers">
				<th class="table__cell table__cell--header" v-for="header in headers" @click="onHeaderClick(header)" :key="header">
					{{ headerName(header) }}
				</th>
			</tr>
		</thead>
		<tbody class="table__body">
			<tr class="table__row table__row--data" v-for="row in rows" @click="onRowClick(row)" :key="keyFactory(row)">
				<td class="table__cell table__cell--data" v-for="header in headers" :key="header">
					{{ row[header] | abbr(abbreviateLength) }}
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	import VueTypes from "vue-types"
	import { identity } from "@/utils/functions"
	import { generateSequence } from "sequency"

	export default {
		props: {
			headers: VueTypes.arrayOf(VueTypes.string).def([]),
			rows: VueTypes.arrayOf(VueTypes.object).def([]),
			keyFactory: VueTypes.func.def(identity),
			headerName: VueTypes.func.def(identity),
			abbreviateLength: VueTypes.integer.def(20),
		},
		methods: {
			onRowClick(row){
				this.$emit("rowClick", row);
			},
			onHeaderClick(row){
				this.$emit("headerClick", row);
			},
		},
		filters: {
			/**
			 * @param {string} str
			 */
			abbr(str, max = 20){
				if(!str)
					return generateSequence(() => " ").take(max).joinToString({
						separator: "",
					});

				if(typeof str != "string"){
					return str;
				}

				const ellipsis = " [...]";
				const delta = max - ellipsis.length;
				if(delta <= 0)
					return ellipsis.substr(1);

				return str.length < max
				? str
				: str.substr(0, delta) + ellipsis;
			}
		},
	}
</script>

<style lang="scss" scoped>
	@use "~@scss/components/Datatable" as *;
</style>